import React from 'react';

export const DEFAULT_ERROR =  'Error.';
export const NETWORK_ERROR =
	'Network Error: The server encountered an error and was unable to complete your request.';
export const CORRECT_THE_FOLLOWING_TITLE = "Please correct the following error(s): ";
export const REQUIRED_ERROR = 'This field is required';
export const EMPTY_FIELDS_ERROR = 'Fill in all required fields';
export const FIX_INVALID_ERROR = 'Correct any invalid inputs';
export const MAX_ATTACHMENTS_ERROR =
	'You have reached the maximum allowed number of attachments.';
export const MAX_PARTIES_ERROR =
	'You have reached the maximum allowed number of parties.';
export const MAX_DOCKET_NUMBERS_ERROR =
	'You have reached the maximum allowed number of docket numbers.';
export const MAX_EMAILS_ERROR = "Maximum of 10 Additional Email Addresses Allowed per Party";

export const getMaxFieldLengthError = (maximum, length) => `Please enter a maximum of ${maximum} characters. You have entered ${length} characters`;

export const DUPLICATE_DOCKET_NUM_ERROR = "Duplicate Docket Number entered.";
export const DUPLICATE_ERROR = 'Duplicate file name.';
export const INVALID_EXT_ERROR = 'Invalid file extension.';
export const PDF_EXTENSION_ERROR = 'The file must be a PDF';
export const INVALID_CHARS_ERROR = 'File names can only contain letters, numbers and underscores.';
export const FILE_NAME_TOO_LONG_ERROR = 'File name exceeds 150-character limit.';
export const FILE_NAME_TOO_SHORT_ERROR = 'File name must have a minimum of 1 character.';
export const TOO_LARGE_ERROR = 'File size too large.';
export const INVALID_EMAIL_ERROR = 'Invalid email entered for party';
export const INVALID_ADDITIONAL_EMAIL_ERROR = 'Invalid email address';
export const PDF_REQUIREMENT_ERROR = 'At least one of the files must be a PDF';
export const FILE_REQUIREMENT_ERROR = 'Attach at least one file';
export const NO_LABEL_ERROR = '';
export const NULL_FILE_ERROR = 'Tried to upload a NULL file!';
export const INVALID_DATE_ERROR = "Invalid Date";
export const INVALID_PRIMARY_RECORDATION_FORMAT_ERROR = "Please only enter the Primary Recordation # (e.g. W123 or 30124)";
export const UPLOADING_ATTACHMENT_ERROR = 'Error uploading attachment';
export const UPLOAD_ATTACHMENT_ERROR_ID = 'uploadAttachmentError';
export const UPLOADING_FILING_ERROR = "Error uploading filing";
export const UPLOADING_FILING_ERROR_ID = "uploadFilingError";

export const ERROR_BOUNDARY_TITLE = "Internal Server Error";
export const ERROR_BOUNDARY_TEXT = "There is a problem with the page you requested. Try reloading the page, or navigate to another page to continue.";

export const INVALID_NUMBER_ERROR = "This field must be a number";
export const NUMBER_OUT_OF_RANGE = "Number out of range";
export const INVALID_ICON = (errorMessage) => <span className="invalid-info" title={errorMessage}>?</span>;
export const ERROR_DISPLAYING_RESULTS = "Error: Cannot display results";
export const INVALID_PHONE_NUMBER_ERROR = 'Please enter a valid phone number';
export const INVALID_FAX_NUMBER_ERROR = 'Please enter a valid fax number';